import {
    ApplicationSettings,
    ApplicationType,
    Audit,
    EntityTemplate,
    ItemId,
    TemplateId,
    TemplateVersionStatus,
    Version,
    VersionId
} from "./common"
import { MetaValues } from "./form"
import { WithTitle } from "../../utility/common/withTitle"
import { Agent } from "../agent"
import { Channel } from "../channel"
import { TreeData, TreeItem } from "@atlaskit/tree"
import { SlotDto } from "../slot"

export interface ApplicationDescriptions {
    Usage: string // Инструкция по установке и подключению
    ChangeLog: string // Комментарий для разработчиков
}

export interface ApplicationTemplate {
    Id: TemplateId
    Icon?: string
    Title: string
    Description: string
    AutoPublished: boolean
    ApplicationType: ApplicationType
    Audit: Audit
}

export interface ApplicationTemplateVersion {
    Id: VersionId
    TemplateId: TemplateId
    Version: Version
    Title: string
    Settings: ApplicationSettings
    EntitiesTemplates: EntityTemplate[]
    Meta: MetaValues
    Descriptions: ApplicationDescriptions
    Status: TemplateVersionStatus
    Audit: Audit
}

export enum ApplicationTemplateSidebarContentType {
    addAgentForm,
    addChannelForm,
    changeAgentForm,
    changeChannelForm,
    addSlotForm,
    changeSlotForm
}

export interface ApplicationTemplateSidebarContent extends WithTitle {
    type: ApplicationTemplateSidebarContentType
    agent?: Agent
    channel?: Channel
    slot?: SlotDto
    settings?: JSX.Element[]
    stepBack?: boolean
    onBack?: () => void
}

export interface ApplicationTemplateTreeData extends TreeData {
    items: Record<ItemId, ApplicationTemplateTreeItem>
}

export interface ApplicationTemplateTreeItem extends TreeItem {
    data: ApplicationTemplateTreeItemData
}

export type ApplicationTemplateTreeItemData = {
    id: VersionId
    title: string
    parentId: TemplateId
} & ApplicationTemplateVersionCategory

export interface ApplicationTemplateMutation {
    Id: TemplateId
    VersionId?: VersionId
    Status?: TemplateVersionStatus
    Title?: string
    Audit?: Audit
}

export interface ApplicationTemplateCategory {
    Id: TemplateId
    Title: string
    Audit: Audit
    Versions: ApplicationTemplateVersionCategory[]
}

export interface ApplicationTemplateVersionCategory {
    Id: VersionId
    Title: string
    Status: TemplateVersionStatus
    Audit: Audit
}

export enum ApplicationEditType {
    MAIN_APPLICATION = "main-application",
    VERSION_APPLICATION = "version-application"
}
